import axiosClient from './axiosClient';

const courseApi = {
  create: (data) => {
    const url = '/courses';
    return axiosClient.post(url, data);
  },
  edit: (id, data) => {
    const url = `/courses/${id}`;
    return axiosClient.put(url, data);
  },
  whiteBoard: (id, data) => {
    const url = `/courses/${id}/updateWhiteBoardImages`;
    return axiosClient.put(url, data);
  },
  updateIntake: (data) => {
    const url = '/intakes/update-bulk-intakes-status';
    return axiosClient.put(url, data);
  },
  upDateClass: (id, data) => {
    const url = `/courses/class/${id}`;
    return axiosClient.put(url, data);
  },
  delete: (id) => {
    const url = `/courses/${id}`;
    return axiosClient.delete(url);
  },
  getList: (params) => {
    const url = '/courses';
    return axiosClient.get(url, {
      params,
    });
  },

  /**
   *
   * @param {{advanceFilter: import('api/axiosClient').AdvanceFilterReturn}} data
   * @param {{params: import('api/axiosClient').FilterParamsPros}} options
   * @returns {import('components/React-table/commonCellAction').INIT_DATA & {data: any[]}}
   */
  getAdvanceFilter: async (data, { params }) => {
    return await axiosClient.post('/courses/advance-filter', data, {
      params,
    });
  },
  getCourseWithPrice: (params, price) => {
    const url = `/courses?${price}`;
    return axiosClient.get(url, {
      params,
    });
  },
  getById: (id, params) => {
    const url = `/courses/${id}`;
    return axiosClient.get(url, { params });
  },
  getTeachingLanguages: () => {
    const url = '/teaching-languages';
    return axiosClient.get(url);
  },
  checkImportUser: (id, data) => {
    const url = `/courses/check-import-user/${id}`;
    return axiosClient.post(url, data);
  },
  importUser: (id, data) => {
    const url = `/courses/import-user/${id}`;
    return axiosClient.post(url, data);
  },
  createIntake: (data, courseId) => {
    const url = `courses/${courseId}/create-intake`;
    return axiosClient.post(url, data);
  },
  getIntakes: (params, options) => {
    const url = `courses/${options.courseId}/get-intake`;
    return axiosClient.get(url, { params });
  },
  /**
   *
   * @param {*} params
   * @param {*} options
   * @returns {Promise<any[]>}
   */
  getCourseUnits: (params, options) => {
    const url = `/courses/${options.id}/units`;
    return axiosClient.get(url, { params });
  },
  searchCourses: (params) => {
    const url = '/courses/search';
    return axiosClient.get(url, { params });
  },
  createCourseRulesAndPath: (data) => {
    const url = '/course-rules-and-path';
    return axiosClient.post(url, data);
  },
  /**
   *
   * @param {*} id
   * @returns {Promise<any>}
   */
  getCourseRuleAndPath: (id) => {
    const url = `/course-rules-and-path/${id}`;
    return axiosClient.get(url);
  },
  updateRulesAndPath: (id, data) => {
    const url = `/course-rules-and-path/${id}`;
    return axiosClient.put(url, data);
  },
  IntakeSectionPopup: (params) => {
    const url = `/units/get-units`;
    return axiosClient.get(url, { params });
  },
  getAllCourse: () => {
    const url = `/courses/getAllCourses`;
    return axiosClient.get(url);
  },
  createReminderRules: (data) => {
    const url = 'course-rules-and-path/course-master-rule';
    return axiosClient.post(url, data);
  },
  fetchReminderRules: (params) => {
    const url = `course-rules-and-path/course-master-rules`;
    return axiosClient.get(url, { params });
  },
  advanceFilterReminderRules: (data, options) => {
    const url = `course-rules-and-path/course-master-rules`;
    return axiosClient.post(url, data, options);
  },
  getReminderById: (id) => {
    const url = `course-rules-and-path/course-master-rule/${id}`;
    return axiosClient.get(url);
  },
  updateReminderRules: (id, data) => {
    const url = `course-rules-and-path/course-master-rule/${id}`;
    return axiosClient.put(url, data);
  },
  deleteReminderRules: (id) => {
    const url = `course-rules-and-path/course-master-rule/${id}`;
    return axiosClient.delete(url);
  },
  getHistoryReminderRules: (params) => {
    const url = `course-rules-and-path/course-master-rules-log`;
    return axiosClient.get(url, { params });
  },

  getAdaptiveTests: (params) => {
    const url = `/courses/${params.id}/adaptive-tests`;
    return axiosClient.get(url, { params });
  },
};

export default courseApi;
